export default "__VITE_ASSET__CONXN4_R__"